<script lang="ts">
/**
 * @component LocalizedLink
 *
 * A drop-in replacement for the native `<a>` element that automatically
 * prefixes the `href` with the current Intlayer locale via
 * `getLocalizedUrl()`. All additional HTML anchor attributes are forwarded
 * through rest props, making this component fully transparent to consumers.
 */
import { page } from "$app/state";
import { languages } from "$lib/lang";

let { href = "", children, ...restProps } = $props();

let currentLocale = $derived(page.url.pathname.split("/")[1]);
let isSupported = $derived(languages.some((l) => l.code === currentLocale));

let localizedHref = $derived.by(() => {
  if (
    !href ||
    href.startsWith("http") ||
    href.startsWith("mailto:") ||
    href.startsWith("tel:")
  )
    return href;

  if (!isSupported) return href;

  const hasSupportedPrefix = languages.some(
    (l) => href.startsWith(`/${l.code}/`) || href === `/${l.code}`,
  );
  if (hasSupportedPrefix) return href;

  const cleanHref = href === "/" ? "" : href;
  return `/${currentLocale}${cleanHref}`;
});
</script>

<a href={localizedHref} hreflang={currentLocale} {...restProps}>
  {@render children?.()}
</a>
